<template>
	<div class="login-box" v-if="showpage">
		<img class="bg-img" :src="xgTheme.loginBg" />
		<div class="opt-div">
			<Option :openId="openId" :providerCode="providerCode" :color="xgTheme.loginOptionColor" :bgColor="xgTheme.loginOptionBgColor"></Option>
		</div>
		<div class="input-div" v-if="xgTheme.inputTopPosition!=null" :style="{'top':xgTheme.inputTopPosition+'%'}">
			<van-field v-model="mobile" type="number" maxlength="11" input-align="center" :border="false" placeholder="请输入中国移动号码" />
		</div>
		<div class="login-btn-div t-c" v-if="xgTheme.btnTopPosition!=null" :style="{'top':xgTheme.btnTopPosition+'%'}">
			<img :src="xgTheme.loginBtBg" @click="mobilelogin" />
		</div>
		<div class="auth-div t-c" v-if="xgTheme.loginAuthPosition!=null " :style="{'top':xgTheme.loginAuthPosition+'%'}">
			<div class="flex_center">
				<van-checkbox v-model="agree" icon-size="20px" :checked-color="xgTheme.loginAuthColor">
					<span class="f-s-12">同意</span>
					<span class="blue f-s-12" :style="{'color':xgTheme.loginAuthColor}" @click="toUserAggerment">《畅由用户协议》</span>
				</van-checkbox>
			</div>
		</div>
		
		<div class="back-vip-div" @click="toBackVip()" v-if="providerCode == 'MGTV' && xgTheme.loginBackVipPosition!=null" :style="{'top':xgTheme.loginBackVipPosition+'%'}">
			返回领会员首页
		</div>

	</div>
</template>
<script src="https://static.tongdun.net/monitor/monitor.js" async crossorigin="anonymous"></script>
<script>
	import {
		Toast
	} from 'vant';
	import {
		mapState,
		mapGetters,
		mapMutations,
		mapActions
	} from "vuex"
	import {
		loginForOpenId,
		loginForMobile,
		getThemeConfig,
		addLoginLog
	} from '@/request/api';
	import Option from '../components/home/Option.vue'
	export default {
		computed: mapGetters(['xgIsChangeAccount', 'xgUserInfo', 'xgTheme']),
		components: {
			[Option.name]: Option
		},
		created() {
			this.init();
		},
		name: 'Login',
		data() {
			return {
				mobile: '',
				region: '',
				openId: '',
				sessionid: '',
				providerCode: '',
				agree:true,
				fingerprint: '',
				showpage: false,
				agreementUrl:'https://m.changyoyo.com/my/account/agreement.html?spm=3.1.102784.0.0.939391628662541391.02011685.02011685'
			}
		},
		methods: {
			...mapMutations(['xsUserInfo', 'xsToken', 'xsIsChangeAccount', 'xsTheme']),
			init() {
				this.timer = setTimeout(this.showCurrentPage, 2000);
				if (!this.xgIsChangeAccount) {
					//清除Token及用户信息
					this.xsUserInfo('')
					this.xsToken('')
					this.xsTheme('')

					let uri = window.location.href.split("#")[0]

					//获取区域和OpenId
					this.region = this.getUrlParam('areaNo', uri)
					this.openId = this.getUrlParam('openid', uri)
					this.providerCode = this.getUrlParam('providerCode', uri)
					this.mobile = this.getUrlParam('mobile', uri)
					if(!this.providerCode){
						this.providerCode = 'nongfu'
					}
					if(this.openId){
						this.createdLoginLog()
					}
					//获取当前主题
					this.getTheme(this.providerCode)

					//获取两个参数
					this.sessionid = window.sessionId
					//调用模拟登录
					this.getTD(true)
					
				} else {
					this.xsIsChangeAccount(false)
					this.sessionid = window.sessionId
					// this.fingerprint = this.xgUserInfo.fingerprint
					this.openId = this.xgUserInfo.openId
					this.region = this.xgUserInfo.region
					this.providerCode = this.xgUserInfo.providerCode
					// this.sessionid = this.xgUserInfo.sessionid
					this.getTD(false)
					//切换账户
					this.showCurrentPage()
				}

			},
			createdLoginLog(){
				addLoginLog({
					openId: this.openId,
					providerCode: this.providerCode,
					region: this.region,
					mobile: this.mobile
				}).then(res => {
					
				})
			},
			showCurrentPage() {
				this.showpage = true
			},
			getTheme(providerCode) {
				getThemeConfig({
					providerCode: this.providerCode
				}).then(res => {
					this.xsTheme(res)
				})
			},
			mobilelogin() {
				if(!this.agree){
					Toast.fail('请同意畅游用户协议');
					return
				}
				let mobileReg = /^1[3-9]\d{9}$/;
				if (!mobileReg.test(this.mobile)) {
					Toast.fail('手机号格式错误');
					return
				}
				loginForMobile({
					fingerprint: this.fingerprint,
					openId: this.openId,
					sessionid: this.sessionid,
					mobile: this.mobile,
					providerCode: this.providerCode,
					region: this.region
				}).then(res => {
					let userInfo = {
						isNew: 1,
						isBindMobile: 1,
						providerCode: this.providerCode,
						fingerprint: this.fingerprint,
						openId: this.openId,
						region: this.region,
						sessionid: this.sessionid,
						mobile: this.mobile,
						cyScore: 0,
						isImpower: 0
					}
					//存入vuex
					this.xsUserInfo(userInfo)
					this.xsToken(res)
					//页面跳转
					this.$router.replace("home");
				})
			},
			openIdLogin() {
				loginForOpenId({
					fingerprint: this.fingerprint,
					openId: this.openId,
					mobile:this.mobile,
					region: this.region,
					providerCode: this.providerCode,
					sessionid: this.sessionid
				}).then(res => {
					//老用户且绑定了手机号且必须授权
					if (res.isNew == 1 && res.isBindMobile == 1 && res.isImpower == 1) {
						res.openId = this.openId
						res.providerCode = this.providerCode,
							res.fingerprint = this.fingerprint
						res.sessionid = this.sessionid
						res.region = this.region,
							//存入vuex
							this.xsUserInfo(res)
						this.xsToken(res.token)
						//页面跳转
						this.$router.replace("home");
					}
				})
			},
			getTD(isLogin) {
				let _this = this
				window._fmOpt = {
					partner: 'changyou',
					appName: 'changyou_web',
					token: 'changyou' + "-" + new Date().getTime() + "-" + Math.random().toString(16).substr(2),
					fmb: true,
					success: function(data) {
						_this.fingerprint = data
						// 在成功完成采集后，success回调中可以获取到blackbox，在获取到blackbox后传输过程中请进行url编码
						if (isLogin) {
							_this.openIdLogin()
						}
					},
					fpHost: "https://fp.tongdun.net"
					// fpHost: "https://fptest.tongdun.net"
				}
				var cimg = new Image(1, 1)
				cimg.onload = function() {
					_fmOpt.imgLoaded = true
				}
				cimg.src = "https://fp.tongdun.net/fp/clear.png?partnerCode=changyou&appName=changyou_web&tokenId=" + _fmOpt.token;
				// cimg.src = "https://fptest.tongdun.net/fp/clear.png?partnerCode=changyou&appName=changyou_web&tokenId="+_fmOpt.token
				var fm = document.createElement('script')
				fm.type = 'text/javascript'
				fm.async = true
				fm.src = ('https:' == document.location.protocol ? 'https://' : 'http://') +
					'static.tongdun.net/v3/fm.js?ver=0.1&t=' + (new Date().getTime() / 3600000).toFixed(0)
				var s = document.getElementsByTagName('script')[0]
				s.parentNode.insertBefore(fm, s)
			},
			toUserAggerment(){
				window.location = this.agreementUrl
			},
			toBackVip(){
				window.location = this.xgTheme.backVipUrl
			},
			getUrlParam(name, url) {
				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
				let search = url.split("?")[1];
				if (search) {
					var r = search.substr(0).match(reg);
					if (r !== null) return unescape(r[2]);
					return null;
				} else {
					return null;
				}
			}
		}
	}
</script>

<style scoped>
	.bg-img {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 0;
	}

	.input-div {
		padding: 2px;
		border: 2px #b4b3b3 solid;
		border-radius: 8px;
		width: 260px;
		height: 50px;
		position: absolute;
		left: calc(50% - 130px);
		z-index: 1;
	}

	.login-btn-div {
		width: 200px;
		height: 40px;
		position: absolute;
		left: calc(50% - 100px);
		z-index: 1;
	}
	
	.auth-div {
		width: 100%;
		height: 40px;
		left:0px;
		position: absolute;
		z-index: 1;
	}
	
	.back-vip-div {
		width: 60px;
		text-align: center;
		height: max-content;
		padding: 8px 10px 8px 5px;
		background-color: #474f74;
		color: #ffffff;
		font-size: 10px;
		font-weight: 450;
		right:0px;
		position: absolute;
		border-top-left-radius: 30px;
		border-bottom-left-radius: 30px;
		z-index: 1;
	}

	.login-btn-div img {
		width: 100%;
	}

	.opt-div {
		width: 80px;
		height: max-content;
		position: absolute;
		top: 55px;
		right: 0;
		z-index: 2;
	}

	.rule-div {
		padding: 0 20px;
		width: 100%;
		height: max-content;
		position: absolute;
		top: 520px;
		left: 0;
		z-index: 1;
		background-color: #3c67dc;
	}



	.login-box {
		position: relative;
		width: 100%;
		height: 100%;
	}



	.input-div /deep/ input::-webkit-input-placeholder {
		color: red;
	}

	.input-div /deep/ input:-moz-placeholder {
		color: red;
	}

	.input-div /deep/ input::-moz-placeholder {
		color: red;
	}

	.input-div /deep/ input:-ms-input-placeholder {
		color: red;
	}
	
</style>
